import { render } from "./ArtistSongs.vue?vue&type=template&id=3132a8a0"
import script from "./ArtistSongs.vue?vue&type=script&lang=js"
export * from "./ArtistSongs.vue?vue&type=script&lang=js"

import "./ArtistSongs.vue?vue&type=style&index=0&id=3132a8a0&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__